import * as React from 'react'
import { Link } from 'react-router-dom'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { PropTypes } from 'prop-types'

export default function BreadCrumbPaths({ paths }) {
  return (
    <Stack spacing={2}>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize='small' />}
        aria-label='breadcrumb'
      >
        {paths &&
          paths.map((bc, index) => {
            if (index === paths.length - 1) {
              return (
                <Link
                  to={bc.route}
                  style={{
                    textDecoration: 'none',
                    pointerEvents: 'none'
                  }}
                  key={bc.name.concat(index)}
                >
                  <Typography
                    key={`bc-${bc.name}`}
                    sx={{
                      margin: 4,
                      fontSize: '1em',
                      color: 'blue',
                      fontWeight: 'bold'
                    }}
                  >
                    {bc.name}
                  </Typography>
                </Link>
              )
            } else {
              return (
                <Link
                  to={bc.route}
                  style={{
                    textDecoration: 'none'
                  }}
                  key={bc.name.concat(index)}
                >
                  <Typography
                    key={`bc-${bc.name}`}
                    color='text.primary'
                    sx={{
                      margin: 4,
                      fontSize: '1em',
                      color: 'blue'
                    }}
                  >
                    {bc.name}
                  </Typography>
                </Link>
              )
            }
          })}
      </Breadcrumbs>
    </Stack>
  )
}

BreadCrumbPaths.propTypes = {
  paths: PropTypes.array
}
